import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';

import { ToggleSwitch } from '@C/FormElements';
import services from '@C/Utils/data';
import { authHeader } from '@H';
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  plugins,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

import './styles.scoped.scss';

const chartOptions = {
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      grid: {
        display: false,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
  },
};

const barColors = ['#5A89D1', '#D3789E', '#EAAF00', '#72D275', '#A284BA'];

class DashboardFuelPrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time_stamp: dayjs().format('YYYY-MM-DD'),
      fuelList: [],
      edit: false,
      updated: false,
      date: this.props.date ? this.props.date : dayjs().format('YYYY-MM-DD'),
      disabled: this.props.disabled ? this.props.disabled : false,
      duty_price_change: this.props.duty_price_change || false,
      duty_price_change_done: false,
      enable_duty_price_change: false,
      isSubmitting: false,
    };
  }

  componentDidMount() {
    this.getStockInformation();
  }

  getStockInformation = () => {
    services
      .getStockInformation(this.state.time_stamp)
      .then((response) => {
        this.setState({
          fuelList: response.data.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  toggleDutyPriceChange = () => {
    this.setState({
      enable_duty_price_change: !this.state.enable_duty_price_change,
    });
  };

  handleChange = (e, i) => {
    const fuelList = [...this.state.fuelList];
    fuelList[i][e.target.name] = e.target.value;
    this.setState({ fuelList: fuelList });
  };

  handleCopy = (event) => {
    event.preventDefault();
    let fuelList = [...this.state.fuelList];
    fuelList = fuelList.map((o) =>
      Object.assign(o, { price: o.previous_price }),
    );
    this.setState({ fuelList: fuelList });
  };
  handleCancel = () => {
    this.setState({ edit: !this.state.edit });
  };

  updatePrice = (e) => {
    e.preventDefault();
    if (!this.state.edit) {
      this.setState({ edit: !this.state.edit });
    } else if (
      !this.state.updated ||
      this.state.duty_price_change ||
      this.state.enable_duty_price_change
    ) {
      const tmp = this.state.fuelList.map((item) => {
        return {
          product_uuid: item.product_uuid,
          price: parseFloat(item.price),
          datetime_stamp: this.state.date,
        };
      });
      this.setState({ isSubmitting: true });
      const formData = {
        product_list: tmp,
      };
      const headers = authHeader(1);
      axios
        .post(`${process.env.API_URL}/bunk/fuel-prices/`, formData, { headers })
        .then(() => {
          toast.success('Price updated successfully', {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          });
          this.getFuelPrice();
          if (this.props.onRequestClose) {
            this.props.onRequestClose();
          }
        })
        .catch((e) => {
          console.log(e);
        });
      this.setState({
        edit: !this.state.edit,
        updated: true,
        isSubmitting: false,
      });
    } else {
      const formData = {
        product_list: this.state.fuelList,
      };
      const headers = authHeader(1);
      axios
        .put(`${process.env.API_URL}/bunk/fuel-prices/`, formData, { headers })
        .then((response) => {
          toast.success(response.data.message);
          this.getFuelPrice();
          if (this.props.onRequestClose) {
            this.props.onRequestClose();
          }
        })
        .catch((e) => {
          console.log(e);
          this.setState({ isSubmitting: false });
        });
      this.setState({ edit: !this.state.edit, updated: true });
    }
  };

  handleDate = (e) => {
    this.setState({ time_stamp: e.target.value }, function () {
      this.getStockInformation();
    });
  };

  render() {
    const { fuelList } = this.state;
    const chartData = {
      labels: fuelList.map((item) => item.tank_name),
      datasets: [
        {
          label: 'stock',
          data: fuelList.map((item) => item.opening_reading),
          backgroundColor: barColors,
          borderColor: 'rgba(75, 192, 192, 0)',
          borderWidth: 1,
          borderRadius: 10,
          barPercentage: 0.5,
        },
      ],
    };

    return (
      <>
        <section className="widget">
          <header>
            <div className="stock-info-header">
              <h3> Stock Information </h3>
            </div>
            <div className="input-wrapper">
              <input
                className="cstm-date-input"
                type="date"
                value={this.state.time_stamp}
                onChange={this.handleDate}
              />
            </div>
          </header>
          <main>
            <div className="chart-container" style={{ width: '100%;' }}>
              <Bar data={chartData} options={chartOptions} />
            </div>
          </main>
        </section>
      </>
    );
  }
}

export { DashboardFuelPrice };
